import { render, staticRenderFns } from "./ELoader.vue?vue&type=template&id=afe84e5c"
import script from "./ELoader.vue?vue&type=script&lang=js"
export * from "./ELoader.vue?vue&type=script&lang=js"
import style0 from "./ELoader.vue?vue&type=style&index=0&id=afe84e5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports